import { useEffect, useState } from "react";
import { api } from "../lib/api";
import TopNav from "../components/TopNav.jsx";

// The Persona Contract — the full system prompt Sage runs under, published in plain text
// with a SHA-256 hash. Anyone can verify Sage has not quietly become sycophantic.
export default function PersonaPage() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.persona().then(setD).catch((e) => setErr(e.message));
  }, []);

  return (
    <div className="min-h-screen bg-sage-bg text-sage-text sage-grain relative">
      <TopNav />
      <div className="mx-auto max-w-4xl px-4 md:px-8 py-16">
        <div className="text-xs uppercase tracking-[0.2em] text-sage-muted mb-2">The Persona Contract</div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter uppercase text-sage-text mb-6">
          The exact prompt Sage lives under.
        </h1>
        <p className="text-base text-sage-muted leading-relaxed max-w-3xl mb-8 sage-prose">
          Every other AI product treats its system prompt as a trade secret. Sage publishes it in full, plus a SHA-256 hash. Copy the text into any hasher and verify — if the number below matches, the persona has not been quietly rewritten. Every change is logged on the Ledger as a Persona Diff.
        </p>

        {err && <div className="border border-sage-warn p-3 text-xs text-sage-warn mb-6" data-testid="persona-error">{err}</div>}

        {d && (
          <>
            <div className="grid md:grid-cols-3 gap-4 mb-6 text-xs">
              <div className="border border-sage-border p-4" data-testid="persona-hash">
                <div className="text-[10px] uppercase tracking-[0.15em] text-sage-faint mb-1">SHA-256</div>
                <div className="font-mono text-sage-accent break-all">{d.sha256}</div>
              </div>
              <div className="border border-sage-border p-4">
                <div className="text-[10px] uppercase tracking-[0.15em] text-sage-faint mb-1">Characters</div>
                <div className="tabular-nums text-sage-text text-2xl font-bold">{d.chars.toLocaleString()}</div>
              </div>
              <div className="border border-sage-border p-4">
                <div className="text-[10px] uppercase tracking-[0.15em] text-sage-faint mb-1">Lines</div>
                <div className="tabular-nums text-sage-text text-2xl font-bold">{d.lines}</div>
              </div>
            </div>

            <pre
              data-testid="persona-text"
              className="whitespace-pre-wrap bg-sage-elevated border border-sage-border p-6 text-sm text-sage-muted sage-prose overflow-x-auto"
            >{d.text}</pre>

            <div className="mt-4 text-[10px] uppercase tracking-[0.15em] text-sage-faint">
              To verify: <span className="text-sage-text">echo -n "&lt;paste text above&gt;" | sha256sum</span> — if the hash matches, this is the persona.
            </div>
          </>
        )}
      </div>
    </div>
  );
}
